<!-- 组件说明 -->
<template>
<div>
  <van-nav-bar
      :title="titleName"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="nav_title"
      />
    <div class="success">
      <van-icon name="success" class="icon" />
      <span style="font-size:0.6rem; margin-top:0.32rem;">{{$t('tips.order_success')}}</span>
      <span>{{ count }}{{$t('Pay.to')}}</span>
  </div>
</div>
 
</template>

<script>
//import x from ''
import { NavBar } from 'vant';
import { mapMutations, mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
       titleName:'',//标题名字
       count: '' ,// 倒计时
    };
  },
  computed: {},
  methods: {
    onClickLeft(){
      this.$router.replace('/');
    },
    goChoicePeople() {
      const TIME_COUNT = 59
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            // 跳转到选人加分界面
            this.$router.push('/')
          }
        }, 1000)
      }
    }
  },
  created() {
    // this.goChoicePeople()
    //生命周期 - 创建完成
      this.titleName = this.$store.state.designer.titleName;

      // console.log('=====fbq-OrderSuceess=====',fbq)
      fbq('track', 'Purchase', {value: sessionStorage.getItem('numberValue'), currency: 'USD'});
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.success {
  padding-top: 13rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  .icon {
    font-size: 2rem;
    color: #38f;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/OrderSuccess.vue